export enum EnumModalidade
{
    Importacao = "Importacao",
    Exportacao = "Exportacao"
}

export const EnumModalidadeDescricao = (modalidade: EnumModalidade): string => {
    switch (EnumModalidade[modalidade]) {
        case EnumModalidade.Importacao: return "Importação";
        case EnumModalidade.Exportacao: return "Exportação";
    }
}

export enum EnumPosicaoDescricao {
    Inicio = 1,
    Fim = 2
}

export const EnumPosicaoDescricaoValor = (posicaoDescricao: string): EnumPosicaoDescricao | null => {
    switch (posicaoDescricao) {
        case 'Inicio': return EnumPosicaoDescricao.Inicio;
        case 'Fim': return EnumPosicaoDescricao.Fim;
        default: return null;
    }
}

export enum EnumTipoNotificaoConfiguracao {
    ProcesamentoPlanilhas = "ProcessamentoPlanilhas",
    CapturaPortalUnico = "CapturaPortalUnico",
    AtualizaoAtributosNCMRFB = "AtualizacaoAtributosNCMRFB",
    ProdutosPendentesClassificacaoFiscal = "ProdutosPendentesClassificacaoFiscal"
}

export const EnumTipoNotificaoConfiguracaoDescricao = (tipoNotificacao: EnumTipoNotificaoConfiguracao): string => {
    switch (tipoNotificacao) {
        case EnumTipoNotificaoConfiguracao.ProcesamentoPlanilhas: return "Processamento de Planilhas";
        case EnumTipoNotificaoConfiguracao.CapturaPortalUnico: return "Captura do Portal Único";
        case EnumTipoNotificaoConfiguracao.AtualizaoAtributosNCMRFB: return "Atualização de Atributos das NCMs";
        case EnumTipoNotificaoConfiguracao.ProdutosPendentesClassificacaoFiscal : return "Produtos com Pendências de Classificação Fiscal"
        default: return "";
    }
}

export enum EnumTipoAutomacaoAtributosModificados {
    Backlog = "Backlog",
    Saneamento = "Saneamento"
}

export enum EnumOrigemAutomacaoAtributosModificados {
    Ncm = "Ncm",
    Produto = "Produto",
    VersoesInativas = "VersoesInativas",
}

export enum EnumTipoAutenticacaoEnvioPortalUnico {
    Usuario = 'Usuario',
    Padrao = 'Padrao'
}

export enum EnumTipoExportacaoProduto {
    Fabricante = 'Fabricante',
    Produto = 'Produto',
}

export enum EnumTipoImportacaoPortalUnico {
    PortalUnico = 'PortalUnico',
    Arquivo = 'Arquivo',
}

export enum EnumTipoAutenticacaoCliente {
    Certificado = 'Certificado',
    Chave = 'Chave',
}

export enum EnumTipoArquivo {
    Excel = 1,
    Json = 2
}
